import { render, staticRenderFns } from "./IbxAssessmentSummary.vue?vue&type=template&id=2f43d3dc"
import script from "./IbxAssessmentSummary.vue?vue&type=script&lang=js"
export * from "./IbxAssessmentSummary.vue?vue&type=script&lang=js"
import style0 from "./IbxAssessmentSummary.vue?vue&type=style&index=0&id=2f43d3dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports